import { useState } from "react";
import CompletedOrders from "../CompletedOrders";
import InfiniteScroll from "react-infinite-scroll-component";
import NewOrder from "../NewOrder";
import Scheduled from "./Scheduled";
import Order from "./Order";
import { scheduledOrders } from "../../services/orderService";

const Completed = ({
  setModal,
  orders,
  total,
  hasMore,
  fetchMoreData,
  fetchData,
  hideMap,
  setHideMap,
}) => {
  const [popup, setPopup] = useState(false);
  return (
    <div className="w-100">
      <div className="d-block d-md-flex justify-content-between gap-2">
        <div className="row g-2 mb-2">
          <div className="col-6 col-md-4">
            <button
              onClick={() => setPopup((prev) => !prev)}
              className="btn btn-success-light btn-wave waves-effect waves-light w-100"
            >
              <i className="ri-add-line me-1 fw-medium align-middle"></i>
              New Order
            </button>
          </div>

          <div className="col-6 col-md-4">
            <button
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              className="btn btn-success-light btn-wave waves-effect waves-light w-100 text-nowrap"
            >
              Completed
              <span className="ms-2 badge bg-success">{total ?? 0}</span>
            </button>
          </div>

          <div className="col-12 col-md-4">
            <Order
              Layout={Scheduled}
              setModal={setModal}
              fetchOrders={scheduledOrders}
              hideMap={hideMap}
              setHideMap={setHideMap}
            />
          </div>
        </div>
        <div className="mb-2">
          <button
            onClick={() => setHideMap((prev) => !prev)}
            className="btn btn-primary btn-w-lg w-100 w-md-auto"
          >
            {hideMap === true ? (
              <i className="ri-fullscreen-exit-line me-1 fw-medium align-middle"></i>
            ) : (
              <i className="ri-fullscreen-line me-1 fw-medium align-middle"></i>
            )}
            {hideMap === true ? `Show Map` : `Hide Map`}
          </button>
        </div>
      </div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel1"
      >
        <div className="offcanvas-header d-flex border-bottom border-block-end-dashed">
          <div className="flex-grow-1">
            <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-success-transparent border border-warning border-opacity-25 rounded">
              <span className="d-block fw-medium fs-15">Completed</span>
              <div>
                <span className="badge badge-task bg-success">
                  {total ?? 0}
                </span>
              </div>
            </div>
          </div>
          <button
            type="button"
            className="btn-close px-3"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="row">
            <div className="col-md-12">
              <div>
                <InfiniteScroll
                  dataLength={orders.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  scrollableTarget="completed-scroll"
                  loader={
                    <div className="text-center my-3">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  }
                >
                  <CompletedOrders
                    orders={orders}
                    setModal={setModal}
                    onReRender={fetchData}
                  />
                  {orders?.length === 0 && (
                    <div className="text-center my-5">
                      <img
                        className="mx-auto w-50 my-5"
                        src={`${process.env.REACT_APP_PUBLIC_URL}assets/images/media/backgrounds/no-content.png`}
                        alt="no-content"
                      />
                    </div>
                  )}
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="scheduledOrderCanvas"
        aria-labelledby="scheduledOrderLabel1"
      >
        <div className="offcanvas-header d-flex border-bottom border-block-end-dashed">
          <div className="flex-grow-1">
            <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-success-transparent border border-warning border-opacity-25 rounded">
              <span className="d-block fw-medium fs-15">Scheduled</span>
              <div>
                <span className="badge badge-task bg-success">
                  {total ?? 0}
                </span>
              </div>
            </div>
          </div>
          <button
            type="button"
            className="btn-close px-3"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="row">
            <div className="col-md-12">
              <div>
                <InfiniteScroll
                  dataLength={orders.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  scrollableTarget="completed-scroll"
                  loader={
                    <div className="text-center my-3">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  }
                >
                  <CompletedOrders
                    orders={orders}
                    setModal={setModal}
                    onReRender={fetchData}
                  />
                  {orders?.length === 0 && (
                    <div className="text-center my-5">
                      <img
                        className="mx-auto w-50 my-5"
                        src={`${process.env.REACT_APP_PUBLIC_URL}assets/images/media/backgrounds/no-content.png`}
                        alt="no-content"
                      />
                    </div>
                  )}
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewOrder popup={popup} setPopup={setPopup} />
    </div>
  );
};

export default Completed;
